import { render, staticRenderFns } from "./MenuSwiperApp.vue?vue&type=template&id=3e470f24&scoped=true&"
import script from "./MenuSwiperApp.vue?vue&type=script&lang=js&"
export * from "./MenuSwiperApp.vue?vue&type=script&lang=js&"
import style0 from "./MenuSwiperApp.vue?vue&type=style&index=0&id=3e470f24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e470f24",
  null
  
)

export default component.exports